import facebookIcon from '../../../media/SocialMedia/logo-facebook.png'
import instagramIcon from '../../../media/SocialMedia/logo-instagram.png'
import linkedinIcon from '../../../media/SocialMedia/logo-linkedin.png'
import twitterIcon from '../../../media/SocialMedia/logo-twitter.png'
import youtubeIcon from '../../../media/SocialMedia/logo-youtube.png'
import { palette } from '../../design/StyleGuide/StyleGuide'

export default {
  homeLinks: [
    {
      url: `https://www.yoco.co.za/za/`,
      label: `Home`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/credit-card-readers/`,
      label: `Card Machines`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/transaction-fees`,
      label: `Fees`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://get.yoco.help/hc/en-za`,
      label: `Support`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/contact`,
      label: `Contact`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
  ],
  businessToolsLinks: [
    {
      url: `https://www.yoco.co.za/za/point-of-sale-app/`,
      label: `Point of Sale`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/portal`,
      label: `Business Portal`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/capital/`,
      label: `Capital`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/integrations`,
      label: `Integrations`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    // {
    //   url: `https://www.yoco.co.za/za/yoco-store`,
    //   label: `Shop`,
    //   linkColor: '#D8D8D8',
    //   hoverColor: palette.action,
    // },
  ],
  aboutLinks: [
    {
      url: `https://www.yoco.co.za/za/about`,
      label: 'About',
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/press`,
      label: `Media`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/blog`,
      label: `Blog`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/careers`,
      label: `Careers`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://promo.yoco.co.za/referrals`,
      label: `Refer a Friend`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://developer.yoco.com/ios-sdk/`,
      label: `Developers`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://www.yoco.co.za/za/terms/`,
      label: `Legal`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
    {
      url: `https://yoco.store/`,
      label: `Shop`,
      linkColor: '#D8D8D8',
      hoverColor: palette.action,
    },
  ],
  connectLinksNew: [
    {
      label: 'Support',
      emailAddress: 'support@yoco.com',
      telephone: '+27 87 550 9626',
      additionalText: '(09h00 - 22h00)',
      linkColor: palette.action,
      hoverColor: palette.action,
    },
    {
      label: 'Sales',
      emailAddress: 'sales@yoco.com',
      telephone: '+27 87 551 7000',
      additionalText: '(09h00 - 17h00)',
      linkColor: palette.action,
      hoverColor: palette.action,
    },
    {
      label: 'Capital',
      emailAddress: 'capital@yoco.com',
      telephone: '+27 87 551 7008',
      additionalText: '(09h00 - 17h00)',
      linkColor: palette.action,
      hoverColor: palette.action,
    },
  ],
  socialMediaLinks: [
    {
      url: `https://www.facebook.com/YocoZA`,
      label: `Facebook`,
      icon: facebookIcon,
    },
    {
      url: `https://www.instagram.com/yoco_za/`,
      label: `Instagram`,
      icon: instagramIcon,
    },
    {
      url: `https://www.linkedin.com/company/yoco/`,
      label: `LinkedIn`,
      icon: linkedinIcon,
    },
    {
      url: `https://twitter.com/Yoco_ZA`,
      label: `Twitter`,
      icon: twitterIcon,
    },
    {
      url: `https://www.youtube.com/channel/UCjcas3l1Uh5NKavSIHunwwA`,
      label: `Youtube`,
      icon: youtubeIcon,
    },
  ],
}



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Footer/FooterLinks.js